<template>
  <div v-once id="bu-app-config" :class="$style.container"></div>
</template>

<script>
// import { get } from 'lodash-es'
// import { mapActions } from 'vuex'

// import API_CONSTANTS from '@/js/helper/api-constants.js'

// import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
// import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'

import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'

export default {
  name: 'BuAppConfig',
  props: {
    config: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      parsedConfig: parseDataAttributeJson(this.config, {
        fallbackId: 'bu-app-config',
        fallbackType: 'bu-app-config',
      }),
    }
  },
  // created() {
  //   if (this.parsedConfig) {
  //     const attributes = get(this.parsedConfig, API_CONSTANTS.ATTRIBUTES, {})
  //     const links = get(this.parsedConfig, API_CONSTANTS.LINKS, {})
  //     const relationships = get(this.parsedConfig, API_CONSTANTS.RELATIONSHIPS, {})
  //     this.setAppConfig({
  //       ...attributes,
  //       links,
  //       relationships,
  //     })
  //   }
  // },
  // methods: {
  //   ...mapActions(STOREMODULES.APP, {
  //     setAppConfig: APP_ACTIONS.SET_APP_CONFIG,
  //   }),
  // },
}
</script>

<style lang="scss" module>
.container {
  position: absolute !important;

  display: none;
  width: 1px;
  height: 1px;
  overflow: hidden;

  white-space: nowrap;

  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
}
</style>
